export default __webpack_public_path__ + "static/media/0345.68a31bab.jpg";